module.exports = __webpack_public_path__ + "static/media/CHERI-01.1ad34302.svg";